import { useProfileLunarStore } from "@/store/profiles/profileLunar.store";
import { useEffect } from "react";

const useProfileLunar = (uid: string) => {
  const { profileLunar, loading, error, fetchProfileLunar } =
    useProfileLunarStore();

  useEffect(() => {
    if (uid) {
      fetchProfileLunar(uid);
    }
  }, [uid, fetchProfileLunar]);

  return {
    profileLunar,
    loading,
    error,
    refetch: () => fetchProfileLunar(uid),
  };
};

export default useProfileLunar;
